import React from 'react';
import { motion } from 'framer-motion';

const TermsPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 animate-fade-in">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <p className="text-xs tracking-widest uppercase text-nude mb-3">
          Legal
        </p>
        <h1 className="font-serif text-5xl text-primary mb-12">
          Terms of Service
        </h1>

        <div className="space-y-10 text-sm text-secondary leading-relaxed tracking-wide">
          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Acceptance of Terms
            </h2>
            <p>
              By accessing and using the Lanre Savage website and services,
              you accept and agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use our
              services.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Use of Service
            </h2>
            <p className="mb-4">
              You may use our services only for lawful purposes and in
              accordance with these terms. You agree not to use our services
              in any way that violates applicable laws or regulations.
            </p>
            <p>
              You are responsible for maintaining the confidentiality of your
              account credentials and for all activities that occur under
              your account.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Products and Pricing
            </h2>
            <p className="mb-4">
              All prices are displayed in the selected currency and are
              subject to change without notice. We reserve the right to
              modify or discontinue any product at any time.
            </p>
            <p>
              We make every effort to display accurate product images and
              descriptions, but we do not warrant that product descriptions
              or other content is accurate, complete, or error-free.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Orders and Payment
            </h2>
            <p className="mb-4">
              By placing an order, you represent that you are authorized to
              use the payment method provided. We reserve the right to refuse
              or cancel any order at our discretion.
            </p>
            <p>
              Payment must be received prior to the acceptance of an order.
              We accept payment via Paystack, PayPal, and Google Pay.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Shipping and Delivery
            </h2>
            <p className="mb-4">
              Orders are packed and shipped via USPS or UPS using Pirate
              Ship, our shipping partner. The shipping method you select at
              checkout determines the estimated delivery timeframe and cost;
              the carrier and service used to fulfill it are chosen by us to
              match that timeframe.
            </p>
            <p>
              You will receive a shipping confirmation email with a tracking
              number once your order has been dispatched. Delivery times are
              estimates and are not guaranteed, as they depend on the
              carrier.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Intellectual Property
            </h2>
            <p>
              All content on this website, including text, graphics, logos,
              images, and software, is the property of Lanre Savage and is
              protected by applicable intellectual property laws.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Limitation of Liability
            </h2>
            <p>
              To the fullest extent permitted by law, Lanre Savage shall not
              be liable for any indirect, incidental, special, consequential,
              or punitive damages arising from your use of our services.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Changes to Terms
            </h2>
            <p>
              We reserve the right to modify these terms at any time. Changes
              will be effective immediately upon posting. Your continued use
              of our services constitutes acceptance of the modified terms.
            </p>
          </div>

          <p className="text-xs text-nude">
            Last updated: January 2026
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default TermsPage;